import { HTMLAttributes } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ProgressBar from "@/components/ProgressBar";
import { useGameContext } from "@/contexts/game-context";
import StageType from "@/types/stage-type";

export const Controls = (props: HTMLAttributes<HTMLDivElement>) => {
  const { state, controls } = useGameContext();

  const { song, stageNumber, playing } = state;
  const { play, pause, restart, changeStage } = controls;

  return (
    <div {...props}>
      <div className="flex gap-2 justify-evenly">
        <button
          className="size-12 ring-2 ring-white text-white bg-blue-500 hover:bg-blue-600 rounded-full flex items-center justify-center"
          onClick={() => restart()}
        >
          <FontAwesomeIcon icon="backward-step" fixedWidth />
        </button>

        {playing ? (
          <button
            className="size-12 ring-2 ring-white text-white bg-yellow-400 hover:bg-yellow-500 rounded-full flex items-center justify-center"
            onClick={() => pause()}
          >
            <FontAwesomeIcon icon="pause" fixedWidth />
          </button>
        ) : (
          <button
            className="size-12 ring-2 ring-white text-white bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center"
            onClick={() => play()}
          >
            <FontAwesomeIcon icon="play" fixedWidth />
          </button>
        )}
      </div>

      <div className="w-full grow flex flex-col rounded border border-gray-400 p-2 gap-2 bg-gray-100">
        <div className="flex gap-2 items-center">
          <select
            className="bg-transparent border border-gray-400 rounded py-1 text-sm sm:text-base w-full"
            value={stageNumber}
            onChange={(e) => changeStage(parseInt(e.target.value, 10))}
          >
            <option value="pre_assessment" disabled>
              Pre-Assessment
            </option>

            {(song?.stages || []).map((stage: StageType) => (
              <option key={stage.id} value={stage.number}>
                {stage.name}
              </option>
            ))}

            <option value="post_assessment" disabled>
              Post-Assessment
            </option>
          </select>

          <button className="rounded-full hover:bg-orange-100 p-2 size-8 border border-orange-400 border-solid flex items-center justify-center text-orange-500">
            <FontAwesomeIcon icon="question" />
          </button>
        </div>

        <div className="rounded border border-gray-400 h-6 w-full bg-white overflow-clip">
          <ProgressBar
            percentage={(100 / 21) * stageNumber}
            text={stageNumber > song.stages.length ? "Stage Complete" : "Progress"}
          />
        </div>
      </div>
    </div>
  );
};
